import { fetchCurrencies } from "@/api/Currency";

let currencies = [];
let currencyMap = new Map();

export async function initCurrencies() {
    const data = await fetchCurrencies();
    currencies = data;
    currencyMap = new Map(data.map(c => [c.code, c]));
}

export function getCurrencyByCode(code) {
    if (!code) {
      return code;
    }

    const currency = currencyMap.get(code);
    if (!currency) {
        throw new Error(`Unknown currency: ${code}`);
    }
    return currency;
}

const currencySigns = {
    RUB: '₽',
    EUR: '€',
    USD: '$',
    AUD: 'AU$',
    JPY: '¥',
    KZT: '₸',
    GBP: '£',
    CNY: '¥',
    TRY: '₺',
    INR: '₹',
    UAH: '₴',
    BRL: 'R$',
    KRW: '₩',
    THB: '฿',
    PLN: 'zł',
    CZK: 'Kč',
    ILS: '₪',
    NGN: '₦',
    PHP: '₱',
    VND: '₫',
    GEL: '₾',
    AZN: '₼',
};

export function getCurrencySignByCode(code) {
    return currencySigns[code] || code;
}

export function getCurrencyMultiplier(currencyCode) {
    const currency = getCurrencyByCode(currencyCode);
    return Math.pow(10, currency.nativeDecimals);
}

export function getStorageMultiplier(currencyCode) {
    const currency = getCurrencyByCode(currencyCode);
    return Math.pow(10, currency.storageDecimals);
}

export function getDisplayDecimals(currencyCode) {
    const currency = getCurrencyByCode(currencyCode);
    return currency.displayDecimals;
}

export function fromStorage(amount, currencyCode) {
    const currency = getCurrencyByCode(currencyCode);
    return Number(amount) / Math.pow(10, currency.storageDecimals);
}

export function toStorage(amount, currencyCode) {
    const currency = getCurrencyByCode(currencyCode);
    return Math.round(Number(amount) * Math.pow(10, currency.storageDecimals));
}

export function toNative(amount, currencyCode) {
    const currency = getCurrencyByCode(currencyCode);
    return Math.round(Number(amount) * Math.pow(10, currency.nativeDecimals));
}

export function getCurrencies() {
    return currencies;
}
